const getBaseDomain = () =>
  process.env.REACT_APP_DOMAIN_NAME || "localhost:5004"

const getProtocol = () => {
  const domain = getBaseDomain()

  return domain.includes("localhost") || domain.includes("127.0.0.1")
    ? "http"
    : "https"
}

const buildLocalAwareUrl = subdomain => {
  const domain = getBaseDomain()
  const host = subdomain ? `${subdomain}.${domain}` : domain

  return `${getProtocol()}://${host}`
}

export default buildLocalAwareUrl
